import { FC } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { Modal } from '@mui/material';
import { CloseIcon /* HideOrShowAccountModalIcon */ } from 'assets';
import { TUpdate } from 'domain/types';
import { Button } from 'view/components';
import * as CS from 'view/modals/styled';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { useUpdateJobPostStatus } from 'view/pages/candidates/hooks/useUpdateJobPostStatus';

const MoveJobPostToDraftModal: FC<{ hideCloseButton?: boolean; successFunction: any }> = ({
  hideCloseButton = false,
  successFunction,
}) => {
  const isOpenMoveJobPostToDraftModal: boolean = useCS(
    GlobalConfigContext,
    globalConfigSelectors.isOpenMoveJobPostToDraftModal
  );

  const jobPostIdToDraft: number | null = useCS(
    GlobalConfigContext,
    globalConfigSelectors.jobPostIdToDraft
  );

  const update: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const { isLoading, updateJobPostStatus } = useUpdateJobPostStatus();

  const onClose = () => {
    if (update) update({ isOpenMoveJobPostToDraftModal: false, jobPostIdToDraft: null });
  };

  const onMoveToDraftClick = () => {
    updateJobPostStatus({ postStatus: 'draft' }, jobPostIdToDraft, successFunction);
  };

  return (
    <Modal
      open={isOpenMoveJobPostToDraftModal}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CS.ModalMainWrapper>
        {!hideCloseButton ? (
          <CS.CloseIconBox onClick={onClose}>
            <CloseIcon />
          </CS.CloseIconBox>
        ) : null}
        <CS.ModalMainBox>
          {/* <CS.ModalMainImage>
            <HideOrShowAccountModalIcon />
          </CS.ModalMainImage> */}
          <CS.ModalMainHeader>
            <CS.ModalMainHeaderTitle>Unpublish and save as draft?</CS.ModalMainHeaderTitle>
            <CS.ModalMainHeaderSubTitle>
              {
                'This job will be hidden from job seekers.\n You can still edit and repost it anytime.'
              }
            </CS.ModalMainHeaderSubTitle>
          </CS.ModalMainHeader>
        </CS.ModalMainBox>
        <CS.ModalMainFooter>
          <Button
            variant="outlined"
            text="Unpublish"
            onClick={onMoveToDraftClick}
            disabled={isLoading}
            style={{ width: '100%', minHeight: '50px' }}
          />
          <Button variant="contained" text="Cancel" onClick={onClose} />
        </CS.ModalMainFooter>
      </CS.ModalMainWrapper>
    </Modal>
  );
};

export default MoveJobPostToDraftModal;
